/* unplugin-vue-components disabled */import script from "./majorBotton.vue?vue&type=script&setup=true&lang=js"
export * from "./majorBotton.vue?vue&type=script&setup=true&lang=js"

import "./majorBotton.vue?vue&type=style&index=0&id=6378e592&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6378e592"]])

export default __exports__